<div class="dialog-title">
  <div class="title">Mark all as read?</div>
  <div mat-dialog-close class="icon-close"><i class="icon-X"></i></div>
</div>

<div class="content">
  This will mark all items in My Topics as read. New updates will still be highlighted when available.
</div>

<div class="actions">
  <app-button
    mat-dialog-close
    [buttonStyleType]="BUTTON_TYPES.SECONDARY_0"
    [buttonSize]="BUTTON_SIZE.FULL_SIZE">Cancel
  </app-button>
  <app-button
    [mat-dialog-close]="true"
    [buttonStyleType]="BUTTON_TYPES.PRIMARY_0"
    [buttonSize]="BUTTON_SIZE.FULL_SIZE">Mark all as read
  </app-button>

</div>
